import React, { useEffect, useRef } from 'react';
import { TweenMax, Power3 } from 'gsap';
import '../styles/Page.scss';

const Fleet = () => {
    let content = useRef(null);

    useEffect(() => {
        TweenMax.to(content, 1, { opacity: 1, y: 0, ease: Power3.easeOut, delay: 0.2 });
    }, []);

    const ShipIcon = ({ type }) => {
        if (type === "Cruiser") return (
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cfaa6e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
            </svg>
        );
        if (type === "Shuttle") return (
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cfaa6e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M13 2L3 14h9v8l10-12h-9l9-8z" />
            </svg>
        );
        return (
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cfaa6e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
            </svg>
        );
    };

    const ships = [
        { name: "The Stargazer", class: "Luxury Cruiser", type: "Cruiser", capacity: 50 },
        { name: "Apollo's Chariot", class: "Speed Shuttle", type: "Shuttle", capacity: 12 },
        { name: "The Titan", class: "Heavy Transport", type: "Transport", capacity: 200 }
    ];

    return (
        <div className="page fleet-page">
            <div className="container" ref={el => content = el}>
                <section className="fleet-intro">
                    <h1>Our Fleet</h1>
                    <p className="intro-text">Engineered for comfort. Designed for the stars.</p>
                </section>

                <section className="fleet-grid-section">
                    <div className="ship-grid">
                        {ships.map((ship, i) => (
                            <div key={i} className="ship-card">
                                <div className="ship-icon"><ShipIcon type={ship.type} /></div>
                                <h3>{ship.name}</h3>
                                <p className="class">{ship.class}</p>
                                <p className="capacity">Capacity: {ship.capacity}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section className="tech-specs-section">
                    <h2 className="section-title">Technical <span>Excellence</span></h2>
                    <div className="specs-container">
                        <div className="spec-item">
                            <h3>Propulsion</h3>
                            <p>Ion-Drive Cyclers capable of sustained 0.1c travel speeds.</p>
                        </div>
                        <div className="spec-item">
                            <h3>Artificial Gravity</h3>
                            <p>Rotational ring corridors providing 0.8g for resident comfort.</p>
                        </div>
                        <div className="spec-item">
                            <h3>Sustainability</h3>
                            <p>100% waste-heat recycling and photonic solar arrays.</p>
                        </div>
                    </div>
                </section>

                <section className="history-section">
                    <h2 className="section-title">Service <span>History</span></h2>
                    <ul className="timeline">
                        <li><strong>2085:</strong> The Stargazer completes its maiden voyage to Titan.</li>
                        <li><strong>2088:</strong> Odyssey Fleet awarded the Interplanetary Safety Medal.</li>
                        <li><strong>2090:</strong> Expansion to Jupiter's moons begins with The Titan.</li>
                    </ul>
                </section>
            </div>
        </div>
    );
};

export default Fleet;
